import { combineReducers } from '@reduxjs/toolkit';
import generalDataSlice from '../slices/generalDataSlice';

const rootReducer = combineReducers({
  generalData: generalDataSlice,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
